import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import InfoBanner from "@/components/InfoBanner";
import QuoteDrawer from "@/components/QuoteDrawer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <InfoBanner />
      <main className="flex-1">{children}</main>
      <Footer />
      <QuoteDrawer />
    </div>
  );
}
